import React from 'react';
import { createRoot } from 'react-dom/client';
import AssessmentsTable from './AssessmentsTable';

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('assessments-table-container');

  if (container) {
    const assessments = JSON.parse(container.dataset.assessments || '[]');
    const hasArchivedDocs = container.dataset.hasArchivedDocs === 'true';

    const root = createRoot(container);
    root.render(
      <React.StrictMode>
        <AssessmentsTable
          initialAssessments={assessments}
          hasArchivedDocs={hasArchivedDocs}
        />
      </React.StrictMode>
    );
  }

  // Keep the existing evaluation highlighting functionality
  if (gon && gon.evals) {
    gon.evals.forEach((eva) => {
      const regex = new RegExp(eva.rule.criteria, 'i');
      const elId = `eval-${eva.id}`;
      const el = document.getElementById(elId);

      if (el && el.children[0]) {
        let sentence = el.children[0].innerText;
        const match = sentence.match(regex);

        if (match) {
          sentence = sentence.replace(regex, '<span class="found">$&</span>');
          el.children[0].innerHTML = sentence;
        }
      }
    });
  }
});
